// Redirects legacy /edit/:taskId routes to the Today view with the task modal open.
import { Navigate, useParams } from 'react-router-dom';

const EditTaskRedirect = () => {
  const { taskId } = useParams();
  return <Navigate to={`/app/today?task=${taskId}`} replace />;
};

export default EditTaskRedirect;
